import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import ServerMonitoringDashboard from '../components/Server/ServerMonitoringDashboard';

export default function ServerDashboardPage() {
  const navigate = useNavigate();
  return (
    <Layout noSidebar={true}>
      <ServerMonitoringDashboard onClose={() => navigate('/tickets')} />
    </Layout>
  );
}
